/** 商品详情页左侧封面图高度（px），可按视觉稿调整 */
export const PRODUCT_DETAIL_COVER_HEIGHT_PX = 360;
